import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_integrations_session_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { useOrgProject } from '@/context/OrgProjectContext/useOrgProject.ts';

type SessionTokenResponse = {
  token: string;
};

type SessionTokenErrorResponse = {
  code: string;
  message: string;
};

type requestProps = {
  integration_type: string;
  sharepoint_tenant_id?: string;
};

const useRetrieveIntegrationSessionToken = (): UseMutationResult<
  SessionTokenResponse,
  AxiosError<SessionTokenErrorResponse>,
  requestProps
> => {
  const apiClient = useApiClient();
  const { projectId } = useOrgProject();

  return useMutation({
    retry: false,
    mutationFn: async ({ integration_type, sharepoint_tenant_id }: requestProps) => {
      const data = {
        project_id: projectId,
        integration_type: integration_type,
        sharepoint_tenant_id,
      };
      const response = await apiClient.post(get_integrations_session_url(), data);
      return response.data;
    },
  });
};

export default useRetrieveIntegrationSessionToken;
